import { render, staticRenderFns } from "./SliceVisual.vue?vue&type=template&id=210186cd&scoped=true&"
import script from "./SliceVisual.vue?vue&type=script&lang=js&"
export * from "./SliceVisual.vue?vue&type=script&lang=js&"
import style0 from "./SliceVisual.vue?vue&type=style&index=0&id=210186cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210186cd",
  null
  
)

export default component.exports